import React, { lazy, useState, useEffect, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import pages from '../nav.json';
import { AuthContext } from '../context/authContext';
import Toast from '../components/Toast';
import Loaders from '../components/Loaders';
import Layout from '../components/Layout';

const importView = file => {
  return lazy(() =>
    import(`./${file}`).catch(() => {
      Toast({
        type: 'error',
        message: `Error in importing ${file}`,
      });
    }),
  );
};

export default function Index() {
  const { loading_user, user } = useContextHook(AuthContext, ['loading_user', 'user']);

  function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  const { view } = useParams();
  const metaViewData = pages;
  const [selectedView, setSelectedView] = useState([]);

  async function loadView(page) {
    const View = await importView(page.file);
    setSelectedView([<View key={page.file} selectView={selectView} />]);
  }

  async function selectView(viewPath) {
    const page = metaViewData.find(elem => elem.path === viewPath || elem.file === viewPath);

    if (!page) {
      Toast({
        type: 'error',
        message: `Page not found: ${viewPath}`,
      });
      return;
    }

    loadView(page);
  }

  useEffect(() => {
    if (!view) return;
    selectView(view);
  }, [view, loading_user]);

  const currentPage = metaViewData.find(elem => elem.path === view || elem.file === view);

  return loading_user || isEmpty(user) ? (
    <Loaders viewLoader />
  ) : (
    <Layout showTemplate={currentPage?.navigations} user={user}>
      <Suspense fallback={<Loaders viewLoader />}>{selectedView}</Suspense>
    </Layout>
  );
}
